import { useEffect, useState } from 'react';

/** Ancho en el que entra la lista de Payment_WEB_Desktop_List (columna + resumen). */
export const WEB_DESKTOP_MIN_WIDTH = 1024;

export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
